import { render, staticRenderFns } from "./aff-program.vue?vue&type=template&id=7a420d16&"
import script from "./aff-program.vue?vue&type=script&lang=js&"
export * from "./aff-program.vue?vue&type=script&lang=js&"
import style0 from "./aff-program.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports